import { type ButtonHTMLAttributes, type PropsWithChildren, forwardRef } from 'react'
import styled from 'styled-components'

export interface BaseButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'id'>, PropsWithChildren {
  id: string
}

const StyledButton = styled.button.attrs({
  className: 'pointer',
})`
  border: none;
  outline: none;
  appearance: none;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`

export const BaseButton = forwardRef<HTMLButtonElement, BaseButtonProps>(
  ({ children, ...props }, ref) => (
    <StyledButton type={'button'} ref={ref} {...props}>
      {children}
    </StyledButton>
  ),
)

BaseButton.displayName = 'BaseButton'
